import { Check } from 'lucide-react';
import { cn } from "@/lib/utils";

const Stepper = ({ steps }) => {
  return (
    <div className="space-y-8">
      {steps.map((step) => (
        <div key={step.title} className="flex items-start space-x-4">
          {/* Circle */}
          <div
            className={cn(
              "flex items-center justify-center w-8 h-8 rounded-full border-2",
              step.status === "completed" && "bg-primary border-primary text-white",
              step.status === "current" && "border-primary bg-white",
              step.status === "upcoming" && "border-gray-300 bg-white"
            )}
          >
            {step.status === "completed" ? (
              <Check className="h-4 w-4" />
            ) : (
              <div
                className={cn(
                  "w-4 h-4 rounded-full",
                  step.status === "current" && "bg-primary",
                  step.status === "upcoming" && "bg-gray-300"
                )}
              />
            )}
          </div>

          {/* Text */}
          <div className="flex-1">
            <p
              className={cn(
                "text-sm font-medium",
                step.status === "upcoming" && "text-gray-500"
              )}
            >
              {step.title}
            </p>
            {step.description && (
              <p className="text-sm text-muted-foreground">{step.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Stepper;
